import React, { useEffect, useState } from "react";
import { fetchCurrentUser } from "../../services/authService";
import { updateUser } from "../../store/authSlice";
import backgroundImage from "../../assets/backgrounds/my_profile_background.svg";
import { useDispatch } from "react-redux";
import ProfileSectionHolder from "./profileSectionHolder";
import ProfileHeader from "./profileHeader";
import { logOutAsync } from "../../store/asyncLogout";
import LoaderSpin from "../Common/LoaderSpin";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileInfo from "./ProfileInfo";
import ChangePassword from "./ChangePassword";
import SupportForm from "./SupportForm";
import SubscriptionPreview from "./Subscription/SubscriptionPreview";

const MyProfile = ({ embedded = false }) => {
  const location = useLocation();
  const [accountSection, setAccountSection] = useState(embedded && location.state?.profileSection === "subscription" ? "subscription" : "profileinfo");
  const dispatch = useDispatch();
  // Refresh the profile from the server whenever Profile opens, so the photo
  // matches the account on every device.
  useEffect(() => {
    fetchCurrentUser()
      .then((fresh) => fresh && dispatch(updateUser(fresh)))
      .catch((err) => console.error(err));
  }, [dispatch]);
  if (embedded) return (
    <div className="min-w-0">
      <div className="flex flex-col xl:flex-row gap-6">
        <nav aria-label="Account settings" className="w-full xl:w-[220px] xl:shrink-0">
          <ProfileSectionHolder embedded onSelect={setAccountSection} activeSection={{ profileinfo: "Profile Information", changepass: "Password Security", support: "Support", subscription: "Subscription" }[accountSection]} />
        </nav>
        <div className="min-w-0 flex-1 order-first xl:order-none">
          {accountSection === "profileinfo" && <div className="max-w-[560px]"><ProfileInfo embedded /></div>}
          {accountSection === "changepass" && <div className="max-w-[560px]"><ChangePassword embedded /></div>}
          {accountSection === "support" && <div className="max-w-[560px]"><SupportForm onDone={() => setAccountSection("profileinfo")} /></div>}
          {accountSection === "subscription" && <><h2 className="text-xl font-bold mb-4">Subscription</h2><SubscriptionPreview /></>}
        </div>
      </div>
    </div>
  );

  return (
    <div className="relative w-full h-full overflow-hidden z-20">
      <div className="w-full h-full  flex flex-col">
        <div
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "110%",
            backgroundRepeat: "no-repeat",
          }}
          className=" w-full h-full  bg-cover bg-bottom basis-[65%]"
        />
        <div className=" bg-[#F6F6F6] basis-[35%]"></div>
      </div>

      <div className=" absolute top-0 left-0 right-0 bottom-0 overflow-y-auto z-20">
        <div className="p-4 min-h-full ">
          <div className="flex justify-between  text-white">
            <p className="text-[20px] font-[500] leading-7 tracking-[1%]">
              My Profile
            </p>
          </div>
          <ProfileHeader />
          <ProfileSectionHolder />
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
